import React, { useContext, useEffect, useState } from "react";

import { useIsSSR } from "react-aria";

import styled from "@emotion/styled";
import { useDebounce } from "use-debounce";

import { DataContext } from "../../../../providers/VacancyDataProvider";
import NewInput from "../../../shared/forms/NewInput";

interface iKeywordSearchProps {
    onChange: (keyword: string) => void;
}

const Container = styled.div`
    position: relative;
    width: 100%;
    flex-grow: 1;
    ${({ theme }) => theme.breakpoints.from.small.css`
       width: 300px;
    `}
`;

const ClearSearch = styled.button`
    all: unset;
    position: absolute;
    right: 5px;
    bottom: -9px;
    font-size: 34pt;
    color: ${({ theme }) => theme.colors.darkGrey.toString()};
    cursor: pointer;
`;

const KeywordSearch = ({ onChange }: iKeywordSearchProps) => {
    const isSSR = useIsSSR();
    const dataContext = useContext(DataContext);
    const { searchKeyword } = dataContext.data;
    const [keyword, setKeyword] = useState<string>(searchKeyword);
    const [debouncedKeyword] = useDebounce(keyword, 500);

    useEffect(() => {
        onChange(keyword);
        if (!keyword) {
            handleClear();
        }
        if (isSSR) return;
        const url = new URL(window.location.href);
        url.searchParams.set("keyword", keyword.toString());
        window.history.pushState({ path: url.href }, "", url);
    }, [debouncedKeyword]);

    const handleClear = () => {
        setKeyword("");
        if (isSSR) return;
        const url = new URL(window.location.href);
        url.searchParams.delete("keyword");
        window.history.pushState({ path: url.href }, "", url);
    };

    return (
        <Container>
            <NewInput
                placeholder="Suchbegriff"
                name="keyword"
                onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                    setKeyword(event.target.value)
                }
                value={keyword}
            />
            <ClearSearch onClick={handleClear}>&times;</ClearSearch>
        </Container>
    );
};

export default KeywordSearch;
